export const userDutch = {
  lang: 'nl',
  data: {
    USER: {
      USERS: 'Gebruikers',
      NEW_USER: 'Nieuwe gebruiker',
      ALL_USERS: 'Alle gebruikers',
      FIRST_NAME: 'Voornaam',
      MIDDLE_NAME: 'Tussenvoegsel',
      LAST_NAME: 'Achternaam',
      NAME: 'Naam',
      ROLE: 'Rol',
      EMAIL: 'E-mail',
      PHONE: 'Mobiel nummer',
      STATES: 'Status',
      PROSPECT: 'Prospect',
      ACTIVE: 'Actief',
      BLOCKED: 'Geblokkkeerd',
      INVITED: 'Uitgenodigd',
      ADMIN: 'Administrator',
      USER: 'Gebruiker',
      REVIEWER: 'Reviewer',
      RESEND_ACTIVATION: 'Stuur activatie e-mail',
      RESEND_INVITE: 'Stuur uitnodigings e-mail',
      RETRIEVE_LOGIN_CREDENTIALS: 'Haal inlogmethodes op',
      RETRIEVING_LOGIN_CREDENTIALS: 'Inlogmethodes worden opgehaald',
      RETRIEVED_LOGIN_CREDENTIALS: 'Inlogmethodes voor {{user}}',
      LOGIN_CREDENTIAL_MAGIC_LINK: 'Onderstaand is de eenmalige loginlink',
      LOGIN_CREDENTIAL_MAGIC_LINK_DISCLAIMER: 'Please use this when you are impersonating the user!',
      LOGIN_CREDENTIAL_ONE_TIME_PASSWORD: 'Onderstaand is de eenmalige woordcode',
      LOGIN_CREDENTIAL_ONE_TIME_PASSWORD_DISCLAIMER: 'Please refrain from using this login method.',
      CLOSE_MODAL: 'Sluit',
      UNBLOCK: 'Deblokkeer',
      BLOCK: 'Blokkeer',
      LAST_LOGIN: 'Laatste login',
      DELETE: 'Verwijder',
      RESEND_SUCCESS: 'Activatie e-mail verstuurd',
      TOTAL_USERS: 'Aantal gebruikers',
      SEND_PASSWORD_RESET_SUCCESS: 'Wachtwoord reset mail verstuurd',
      PASSWORD_RESET: 'Reset wachtwoord',
      EDIT: 'Bewerk gebruiker',
      SAVE: 'Opslaan',
      ORIGIN: 'Herkomst',
      MODIFIED: 'Gegevens bijgewerkt',
      DETAILS: 'Details',
      ADMINS: 'Administraties',
      ADMINISTATION_NAME: 'Naam',
      USERROLE: 'Rol',
      ROLE_ADMIN: 'Admin',
      ROLE_OWNER: 'Eigenaar',
      ROLE_ACCOUNTANT: 'Boekhouder',
      ROLE_READ_ONLY: 'Bekijker',
      ROLE_USER: 'Gebruiker',
      LOGIN: 'Login',
      ERROR_7012: 'Token is nog actief',
      SIDENAV: {
        NAME: 'Gebruiker',
        DETAILS: 'Details',
        ADMINS: 'Administraties',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/users/i18n/nl.ts